import React from 'react'

import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { toPx } from 'common/builder/components/chart/utils/toPx'

export const Title: React.CSSProperties = {
  ...sharedStyles.subheading,
  ...sharedStyles.textSecondary,
  textAlign: 'center',
  marginBottom: toPx(8),
}

export const RowWrapper: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  flexGrow: 1,
}

export const ButtonWrapper: React.CSSProperties = {
  flexGrow: 1,
  width: '100%',
  display: 'flex',
}

export const ButtonWrapperLast: React.CSSProperties = {
  paddingLeft: toPx(6),
}

export const ButtonWrapperFirst: React.CSSProperties = {
  paddingRight: toPx(6),
}
